/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_pomodoro_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use the remaining time to review or refine the work, or start a related small task, rather than ending the session early. Letting the timer run out keeps the rhythm consistent, which is part of what makes the technique effective over a full day.`)
};

const es_timer_pomodoro_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa el tiempo restante para revisar o pulir el trabajo, o comienza una tarea pequeña relacionada, en lugar de terminar la sesión antes de tiempo. Dejar que el temporizador llegue a cero mantiene el ritmo constante, que es parte de lo que hace efectiva la técnica a lo largo de todo el día.`)
};

const de_timer_pomodoro_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutze die verbleibende Zeit, um die Arbeit zu überprüfen oder zu verfeinern, oder beginne eine verwandte kleine Aufgabe, statt die Session vorzeitig zu beenden. Den Timer ablaufen zu lassen, hält den Rhythmus konstant — genau das macht die Technik über einen ganzen Tag hinweg effektiv.`)
};

const nl_timer_pomodoro_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebruik de resterende tijd om het werk te beoordelen of te verfijnen, of begin aan een gerelateerde kleine taak, in plaats van de sessie vroegtijdig te beëindigen. Door de timer te laten aflopen, blijft het ritme consistent — een deel van wat de techniek effectief maakt gedurende een volledige dag.`)
};

const fr_timer_pomodoro_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilisez le temps restant pour relire ou affiner le travail, ou commencez une petite tâche liée, plutôt que de terminer la session en avance. Laisser le minuteur s’écouler entièrement maintient un rythme constant, ce qui contribue à l’efficacité de la technique sur une journée complète.`)
};

const it_timer_pomodoro_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa il tempo rimanente per rivedere o rifinire il lavoro, oppure inizia un piccolo compito correlato, invece di terminare la sessione in anticipo. Lasciar scadere il timer mantiene un ritmo costante, il che è parte di ciò che rende efficace la tecnica per l'intera giornata.`)
};

const pt_br2_timer_pomodoro_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use o tempo restante para revisar ou refinar o trabalho, ou comece uma pequena tarefa relacionada, em vez de encerrar a sessão antes da hora. Deixar o temporizador terminar mantém o ritmo consistente, o que é parte do que torna a técnica eficaz ao longo de um dia inteiro.`)
};

const pt_timer_pomodoro_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use o tempo restante para rever ou aperfeiçoar o trabalho, ou comece uma pequena tarefa relacionada, em vez de terminar a sessão mais cedo. Deixar o temporizador esgotar mantém o ritmo consistente, o que faz parte do que torna a técnica eficaz ao longo de um dia inteiro.`)
};

const ja_timer_pomodoro_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セッションを早めに終わらせるのではなく、残り時間を使って作業を見直したり、関連する小さなタスクに取り組んだりしましょう。タイマーが鳴り切るまで続けることでリズムが一定に保たれ、これが1日を通してこのテクニックを効果的にする要素の一つです。`)
};

const zh_timer_pomodoro_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用剩余时间回顾或完善工作，或开始一项相关的小任务，而不是提前结束这一时段。让计时器完整跑完能保持节奏一致，这也是该方法在一整天中保持有效的原因之一。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_pomodoro_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_pomodoro_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_pomodoro_faq4_a", locale)
	if (locale === "en") return en_timer_pomodoro_faq4_a(inputs)
	if (locale === "es") return es_timer_pomodoro_faq4_a(inputs)
	if (locale === "de") return de_timer_pomodoro_faq4_a(inputs)
	if (locale === "nl") return nl_timer_pomodoro_faq4_a(inputs)
	if (locale === "fr") return fr_timer_pomodoro_faq4_a(inputs)
	if (locale === "it") return it_timer_pomodoro_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_timer_pomodoro_faq4_a(inputs)
	if (locale === "pt") return pt_timer_pomodoro_faq4_a(inputs)
	if (locale === "ja") return ja_timer_pomodoro_faq4_a(inputs)
	return zh_timer_pomodoro_faq4_a(inputs)
};